import {
  UpdateWaitlistMutation,
  UpdateWaitlistMutationVariables
} from "@outschool/gql-frontend-generated";
import { getQueryNames, gql, useMutation } from "@outschool/ui-apollo";

import { ParentWaitlistedClasses } from "../components/WaitlistedClassesList";
import { WaitlistSeatsForParent } from "./WaitlistQuery";
import WaitlistSeatFragment from "./WaitlistSeatFragment";

export const updateWaitlistMutation = gql`
  mutation UpdateWaitlist(
    $createInputs: [CreateWaitlistSeatInput!]!
    $deleteInputs: [String!]!
  ) {
    createWaitlistSeats(inputs: $createInputs) {
      ...WaitlistSeatFragment
    }
    deleteWaitlistSeats(uids: $deleteInputs) {
      ...WaitlistSeatFragment
    }
  }

  ${WaitlistSeatFragment}
`;

export function useUpdateWaitlist() {
  return useMutation<UpdateWaitlistMutation, UpdateWaitlistMutationVariables>(
    updateWaitlistMutation,
    {
      refetchQueries: getQueryNames([
        ParentWaitlistedClasses,
        WaitlistSeatsForParent
      ])
    }
  );
}
